/* INTEGY V249 — hard scale-only filters for broad vehicle collections — 14JUN2026 */
(function(){
  'use strict';
  if (window.INTEGY_V249_SCALE_ONLY_VEHICLE_FILTERS_LOADED) return;
  window.INTEGY_V249_SCALE_ONLY_VEHICLE_FILTERS_LOADED = true;
  document.documentElement.classList.add('integy-v249-scale-only-vehicle-filters');
  if (!/^\/collections\//.test(location.pathname || '')) return;

  function qs(s,r){try{return(r||document).querySelector(s)}catch(e){return null}}
  function qsa(s,r){try{return Array.prototype.slice.call((r||document).querySelectorAll(s))}catch(e){return[]}}
  function clean(s){return String(s==null?'':s).replace(/\s+/g,' ').trim()}
  function handleize(v){v=String(v||'').toLowerCase();try{v=v.normalize('NFKD').replace(/[\u0300-\u036f]/g,'')}catch(e){}return v.replace(/&/g,' and ').replace(/[’']/g,'').replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'')}
  function parts(){return (location.pathname||'').split('/').filter(Boolean)}
  function currentHandle(){var p=parts(),i=p.indexOf('collections');return i>=0&&p[i+1]?handleize(decodeURIComponent(p[i+1])):''}
  function activeHandles(){var p=parts(),i=p.indexOf('collections');if(i<0||!p[i+2]||p[i+2]==='products')return[];return decodeURIComponent(p.slice(i+2).join('/')).split('+').map(handleize).filter(Boolean)}
  function basePath(){var p=parts(),i=p.indexOf('collections');return i>=0&&p[i+1]?'/'+p.slice(0,i+2).join('/'):''}
  function queryString(){try{var p=new URLSearchParams(location.search||'');p.delete('page');p.delete('view');var s=p.toString();return s?'?'+s:''}catch(e){return location.search||''}}
  function uniq(a){var out=[],seen={};(a||[]).forEach(function(v){v=handleize(v);if(v&&!seen[v]){seen[v]=1;out.push(v)}});return out}
  function tagUrl(handles){handles=uniq(handles);return basePath()+(handles.length?'/'+handles.map(encodeURIComponent).join('+'):'')+queryString()}
  function productCount(){var main=qs('main')||document.body, txt=clean(main.textContent||'');var m=txt.match(/(?:^|\s)([\d,]+)\s+products?(?:\s|$)/i);return m?(parseInt(m[1].replace(/,/g,''),10)||0):0}

  var SCALE_ONLY={
    '1-10-and-1-12-rc-vehicles':1,
    '1-18-and-1-24-rc-vehicles':1,
    '1-14-1-18-1-24-off-road-rtr-parts':1,
    'all-terrain-off-road-vehicles':1,
    'rc-tanks':1
  };
  var SCALES=[['1/5','1-5'],['1/6','1-6'],['1/7','1-7'],['1/8','1-8'],['1/10','1-10'],['1/12','1-12'],['1/14','1-14'],['1/16','1-16'],['1/18','1-18'],['1/24','1-24'],['1/28','1-28'],['1/36','1-36']];

  function listNodes(){return qsa('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list')}
  function makeRow(label,handle,active,live){
    var next=active?activeHandles().filter(function(x){return x!==handle}):activeHandles().concat([handle]);
    var a=document.createElement('a');
    a.className='integy-v27-filter-chip integy-v31-checkbox-filter integy-v201-static-filter-row integy-v218-static-filter-row integy-v239-filter-row integy-v247-filter-row integy-v249-scale-row'+(active?' is-active integy-v31-checkbox-filter--active':'');
    a.href=tagUrl(next);
    a.setAttribute('role','checkbox');
    a.setAttribute('aria-checked',active?'true':'false');
    a.setAttribute('data-tag-handle',handle);
    a.setAttribute('data-integy-v247-direct-nav','true');
    a.setAttribute('data-integy-v249-scale-row','true');
    a.innerHTML='<span class="integy-v201-filter-box integy-v200-filter-box" aria-hidden="true"></span><span class="integy-v201-filter-label"></span><span class="integy-v201-filter-count"></span>';
    qs('.integy-v201-filter-label',a).textContent=label;
    qs('.integy-v201-filter-count',a).textContent=active&&live?'('+Number(live).toLocaleString()+')':'';
    return a;
  }

  function apply(){
    var ch=currentHandle();
    if(!SCALE_ONLY[ch]) return;
    document.documentElement.classList.add('integy-v249-scale-only-active');
    qsa('.integy-sidebar-helper').forEach(function(el){el.textContent='Use Scale to narrow this vehicle collection.'});
    qsa('.integy-v200-static-part-filter-details summary span:first-child,.integy-v249-scale-only-details summary span:first-child').forEach(function(el){el.textContent='Scale'});
    qsa('.productgrid--sidebar input[type="search"],.productgrid--sidebar input[type="text"],[data-productgrid-sidebar] input[type="search"],[data-productgrid-sidebar] input[type="text"]').forEach(function(input){
      var ph=(input.getAttribute('placeholder')||'').toLowerCase();
      if(ph.indexOf('filter')>-1 || ph.indexOf('find')>-1) input.setAttribute('placeholder','Find scale...');
    });
    var active=activeHandles(), live=productCount();
    listNodes().forEach(function(list){
      if(list.getAttribute('data-integy-v249-rendered-scale-only')==='true' && !/Loading indexed filters/i.test(list.textContent||'')) return;
      var frag=document.createDocumentFragment();
      SCALES.forEach(function(pair){frag.appendChild(makeRow(pair[0],pair[1],active.indexOf(pair[1])>-1,live))});
      list.innerHTML='';
      list.appendChild(frag);
      list.setAttribute('data-integy-v249-rendered-scale-only','true');
      list.setAttribute('data-integy-v249-scale-only-list','true');
    });
  }

  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest&&e.target.closest('a[data-integy-v249-scale-row="true"]');
    if(!a||!a.href||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    e.preventDefault();
    document.documentElement.classList.add('integy-v247-filter-clicking');
    location.assign(a.href);
  },true);

  function boot(){apply();setTimeout(apply,80);setTimeout(apply,250);setTimeout(apply,900);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('load',function(){[200,800,1800,3600].forEach(function(ms){setTimeout(apply,ms)})},{passive:true});
  try{new MutationObserver(function(muts){var ch=currentHandle();if(!SCALE_ONLY[ch])return;for(var i=0;i<muts.length;i++){var t=muts[i].target;if(t&&t.closest&&t.closest('.productgrid--sidebar,[data-productgrid-sidebar]')){setTimeout(apply,30);return;}}}).observe(document.body||document.documentElement,{childList:true,subtree:true});}catch(e){}
})();
